var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74908 1.98599C7.61624 1.84413 7.38007 1.95447 7.38007 2.17513V3.68827H4.50184C4.35424 3.68827 4.23616 3.81436 4.23616 3.97198V5.01226C4.23616 5.16988 4.35424 5.29597 4.50184 5.29597H7.38007V6.82487C7.38007 7.04553 7.60148 7.15587 7.74908 7.01401L9.93358 4.68126C10.0221 4.58669 10.0221 4.41331 9.93358 4.31874L7.74908 1.98599Z",
    fill: "#8D8E92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85978 7.39229H1.97786C1.84502 7.39229 1.72694 7.28196 1.72694 7.15587V1.8599C1.72694 1.7338 1.83026 1.62347 1.97786 1.62347H5.85978C6.00738 1.62347 6.12546 1.51314 6.12546 1.37128V0.252189C6.12546 0.110333 6.00738 0 5.85978 0H0.546125C0.250922 0 0 0.236427 0 0.504378V8.49562C0 8.77934 0.250922 9 0.546125 9H5.85978C6.00738 9 6.12546 8.88967 6.12546 8.74781V7.61296C6.12546 7.50263 6.00738 7.39229 5.85978 7.39229Z",
    fill: "#8D8E92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu5);
export default __webpack_public_path__ + "static/media/menu5.904ddadeb278d3c1887458eb71d57135.svg";
export { ForwardRef as ReactComponent };